import React from "react";
import { withRouter } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";

//history.length > 1 && ( <div className="header-left"><IconButton onClick={history.goBack}><KeyboardBackspaceIcon /></IconButton></div>
const HeaderBackButton = ({ history }) =>

	history.length > 2 && ( <div className="header-left"><IconButton onClick={history.goBack}><KeyboardBackspaceIcon /></IconButton></div> );

export default withRouter(HeaderBackButton);

